import { Link } from "react-router-dom"
import './Navbar.css';

const Navbar =()=>{
    return (
        <div className="Navbar">
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/team">Team</Link>
            <Link to="/progress">Progress</Link>
            <Link to="/resources">Resources</Link>
            <Link to="/project">Project</Link>
        </div>
    )
}

export default Navbar;
